// ----------------------------------------
// Public
// ----------------------------------------

function textareaAutoResize ($textarea) {
	if (!$textarea.length) {
		return;
	}

	// Textarea Auto Resize
	let formHidden = $('.form-hidden').first();
	if (!formHidden.length) {
		formHidden = $('<div class="form-hidden"></div>');
		$('body').append(formHidden);
	}

	// Set font properties of formHidden
	let fontFamily = $textarea.css('font-family');
	let fontSize = $textarea.css('font-size');
	let lineHeight = $textarea.css('line-height');

	// Firefox can't handle padding shorthand.
	let paddingTop = $textarea.css('padding-top');
	let paddingRight = $textarea.css('padding-right');
	let paddingBottom = $textarea.css('padding-bottom');
	let paddingLeft = $textarea.css('padding-left');

	if (fontSize) { formHidden.css('font-size', fontSize); }
	if (fontFamily) { formHidden.css('font-family', fontFamily); }
	if (lineHeight) { formHidden.css('line-height', lineHeight); }
	if (paddingTop) { formHidden.css('padding-top', paddingTop); }
	if (paddingRight) { formHidden.css('padding-right', paddingRight); }
	if (paddingBottom) { formHidden.css('padding-bottom', paddingBottom); }
	if (paddingLeft) { formHidden.css('padding-left', paddingLeft); }

	// Set original-height, if none
	if (!$textarea.data('original-height')) {
		$textarea.data('original-height', $textarea.innerHeight());
	}

	if ($textarea.attr('wrap') === 'off') {
		formHidden.css('overflow-wrap', 'normal').css('white-space', 'pre');
	}

	formHidden.text($textarea.val() + '\n');
	let content = formHidden.html().replace(/\n/g, '<br>');
	formHidden.html(content);

	// When textarea is hidden, width goes crazy.
	// Approximate with half of window size

	if ($textarea.get(0).offsetWidth > 0 && $textarea.get(0).offsetHeight > 0) {
		formHidden.css('width', $textarea.width() + 'px');
	} else {
		formHidden.css('width', (window.innerWidth / 2) + 'px');
	}

	/**
	 * Resize if the new height is greater than the
	 * original height of the textarea
	 */
	if ($textarea.data('original-height') <= formHidden.innerHeight()) {
		$textarea.css('height', formHidden.innerHeight() + 'px');
	} else if ($textarea.val().length < $textarea.data('previous-length')) {
		/**
		 * In case the new height is less than original height, it
		 * means the textarea has less text than before
		 * So we set the height to the original one
		 */
		$textarea.css('height', $textarea.data('original-height') + 'px');
	}
	$textarea.data('previous-length', $textarea.val().length);
}

// ----------------------------------------
// Exports
// ----------------------------------------

export default textareaAutoResize;



// WEBPACK FOOTER //
// ./src/js/_modules/textarea-auto-resize.js